import { desktopMediaQueryString } from './breakpoints'

const transitionTiming = '0.15s ease-out'
const minHeightTransition = `min-height ${transitionTiming}`
const marginBottomTransition = `margin-bottom ${transitionTiming}`

// "unfilled" means that Google decided not to serve an ad
export default `
.hide-start-page-leaderboard .start-page-leaderboard-container,
.hide-events-page-leaderboard .events-page-leaderboard-container,
.hide-groups-page-leaderboard .groups-page-leaderboard-container {
    display: none;
}

.start-page-leaderboard-container,
.events-page-leaderboard-container,
.groups-page-leaderboard-container {
    min-height: 65px;
    margin-bottom: 16px;
    transition: ${minHeightTransition}, ${marginBottomTransition};
}

.start-page-has-unfilled-leaderboard .start-page-leaderboard-container,
.events-page-has-unfilled-leaderboard .events-page-leaderboard-container,
.groups-page-has-unfilled-leaderboard .groups-page-leaderboard-container {
    display: none;
    margin-bottom: 0;
}

.start-page-has-unfilled-leaderboard .start-page-leaderboard-inner-wrapper,
.start-page-has-unfilled-leaderboard .start-page-leaderboard-controls,
.events-page-has-unfilled-leaderboard .events-page-leaderboard-inner-wrapper,
.events-page-has-unfilled-leaderboard .events-page-leaderboard-controls,
.groups-page-has-unfilled-leaderboard .groups-page-leaderboard-inner-wrapper,
.groups-page-has-unfilled-leaderboard .groups-page-leaderboard-controls {
    display: none;
}

@media only screen and ${desktopMediaQueryString} {
    .start-page-leaderboard-container,
    .events-page-leaderboard-container,
    .groups-page-leaderboard-container {
        min-height: 105px; /* 105 = 90 for the ad + 15 for our text above it */
        transition: ${minHeightTransition};
    }

    .hide-groups-page-leaderboard .start-page {
        padding-top: 72px;
    }

    .hide-groups-page-leaderboard .groups-page {
        padding-top: 88px;
    }

    .start-page-has-unfilled-leaderboard .start-page-leaderboard-container,
    .events-page-has-unfilled-leaderboard .events-page-leaderboard-container,
    .groups-page-has-unfilled-leaderboard .groups-page-leaderboard-container {
        min-height: 0;
    }
}

div.start-page-leaderboard-container {
    margin-bottom: 32px;
    transition: ${marginBottomTransition};
}

.leaderboard-when-is-unfilled div.start-page-leaderboard-container {
    margin-bottom: 0;
}

@media only screen and ${desktopMediaQueryString} {
    div.start-page-leaderboard-container {
        min-height: 137px;
        transition: ${minHeightTransition};
    }

    .start-page-has-unfilled-leaderboard div.start-page-leaderboard-container {
        min-height: 0;
    }
}
`
